import API from "./api";

// ==============================
// ADD ORDER STATUS (ADMIN / STAFF)
// ==============================
export const addOrderStatus = async (orderId, payload) => {
  const token = localStorage.getItem("token");

  const res = await API.post(
    `/order-status/${orderId}`,
    payload,
    {
      headers: {
        Authorization: `Bearer ${token}`,
      },
    }
  );

  return res.data;
};

// ==============================
// GET ORDER STATUS HISTORY
// ==============================
export const getOrderStatusHistory = async (orderId) => {
  const token = localStorage.getItem("token");

  const res = await API.get(`/order-status/${orderId}`, {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  });

  return res.data.history;
};